import { CollectionEventModifyOrders, CollectionEventModifyType } from './generated'
import { getCurrentWindowId } from 'utils'
import { clientActionEvent } from './ClientAction'
import { EntityType } from './EntityType'

export type CollectionModifyTypeArgs = Omit<CollectionEventModifyType, 'eventType' | 'correlationId'>
export type CollectionModifyOrdersArgs = Omit<CollectionEventModifyOrders, 'eventType' | 'correlationId'>

function collectionModifyType(args: CollectionModifyTypeArgs, sourceWindowId: string = getCurrentWindowId()) {
  return clientActionEvent('CollectionEventModifyType', args, sourceWindowId, {
    entityIds: [args.collectionId],
    entityType: EntityType.COLLECTION
  })
}

function collectionModifyOrders(args: CollectionModifyOrdersArgs, sourceWindowId: string = getCurrentWindowId()) {
  return clientActionEvent('CollectionEventModifyOrders', args, sourceWindowId, {
    entityIds: [args.collectionId],
    entityType: EntityType.COLLECTION
  })
}

export const CollectionActions = {
  modifyType: collectionModifyType,
  modifyOrders: collectionModifyOrders
}
